import classNames from 'classnames'
import { graphql } from 'gatsby'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import React from 'react'

import Image from '@/components/image/image'
import Link from '@/components/link/link'
import { generateUrlFromNode } from '@/utils/url'

import * as styles from './persons.module.scss'

export type Props = {
  readonly title: string | null
  readonly isDark: boolean | null
  readonly persons:
    | readonly (Queries.PersonDetailFragment | null | undefined)[]
    | undefined
}

const Persons: React.FC<Props> = ({ persons, title, isDark = false }) => {
  if (isNil(persons) || isEmpty(persons)) return <></>
  return (
    <section
      className={classNames(styles.items, {
        [styles.oneitem]: persons.length === 1,
        [styles.darkMode]: isDark
      })}
    >
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="pb-4">
              <h2>{title}</h2>
            </div>
          </div>
        </div>
        <div className={styles.griditems}>
          {persons.map((item) => {
            if (isNil(item)) return null
            const {
              id,
              firstName,
              secondName,
              photo,
              job,
              linkedin,
              disableProfilePage
            } = item
            const url =
              disableProfilePage === true ? '' : generateUrlFromNode(item)
            return (
              <div key={id}>
                <Link to={url}>
                  <Image image={photo} className={styles.photo} />
                </Link>
                <div className={`${styles.name} pb-3 pt-3`}>
                  <Link to={url}>
                    {firstName} {secondName}
                  </Link>
                </div>
                <div className="pb-3">{job}</div>
                {linkedin !== null && (
                  <a
                    href={linkedin}
                    className={styles.linklinkedin}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="/media/linkedin-icon-link.svg" alt="linkedin" />
                  </a>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Persons

export const query = graphql`
  fragment PersonDetail on DatoCmsGctPerson {
    __typename

    id
    firstName
    secondName
    job
    linkedin
    disableProfilePage
    company {
      __typename
      externalName
      url
      logo {
        url
      }
    }
    photo {
      __typename
      url
      alt
      gatsbyImageData(
        width: 310
        height: 400
        imgixParams: { w: "310", h: "400", fit: "crop", crop: "focalpoint" }
      )
    }
    photoSquare: photo {
      __typename
      url
      gatsbyImageData(
        width: 400
        height: 400
        imgixParams: { w: "400", h: "400", fit: "crop", crop: "focalpoint" }
      )
      alt
    }
    bio
  }

  fragment Author on DatoCmsPctAuthor {
    __typename

    id
    person {
      ...PersonDetail
    }
    bio
  }

  fragment Leader on DatoCmsPctLeader {
    __typename
    id
    person {
      ...PersonDetail
    }
    bio
  }
`
